<template>
 <o-list
      :entity="entity"
      :isAction="false"
      :isAutoLoad="false"
      :isDateRange="true"
      ref="list"
      @openRecord="openRecord($event)"
      @emitRecord="emitRecord($event)"
      @cancelRecord="cancelRecord($event)"
      @handleDate="handleDate($event)"
      :widthModal="width"
      :bodyStyleModal="bodyStyle"
      :resetForm="resetForm"
    >
      <template #tabs>
        <a-tabs
          v-model:activeKey="activeKey"
          :tabBarGutter="0"
          :tabBarStyle="styleTabs"
          @change="changeTabWithEmit"
        >
          <a-tab-pane
            v-for="item in orderCustomerStatus"
            :key="item.value"
            :tab="item.text"
          ></a-tab-pane>
        </a-tabs>
      </template>
    </o-list>

    <o-show
      :showmodal="isShow"
      :form="detail"
      @saveStatus="saveStatus($event)"
      @hideModal="hideModal"
      @reorder="reorder($event)"
    />
</template>
<script>
import Show from "@/pages/OrderCustomer/Show.vue";
import axios from "axios";
import mixins from "@/mixins";
import BaseList from "@/pages/BasePage/BaseList.vue";
// import EventBus from "@/event-bus";
import { useRoute } from "vue-router";
import moment from "moment/moment";
import { datePickerLocale as locale } from "@/common/locale";
import OrderHistory from "@/pages/OrderCustomer/OrderHistory.vue";
// import RightSideBar from "@/components/SidebarPlugin/RightSideBar.vue";
import constant from "@/constant";
import { ref, createVNode } from "vue";
const entity = "order-customer";
export default {
  mixins: [mixins,constant],
  components: {
    "o-list": BaseList,
    "o-show": Show,
    "form-history": OrderHistory,
  },
  data: function () {
    const route = useRoute();
    const activeKey = ref(Number(route.query.status) || -1);
    return {
      dateFormat: "DD/MM/YYYY",
      entity,
      moment,
      data: {},
      fromDate: "",
      toDate: "",
      locale,
      isExport: true,
      isShow: false,
      disabled: false,
      title: window.__t('js.chon_thoi_gian'),
      detail: {},
      widthExport: "400px",
      width: "800px",
      bodyStyleExport: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      bodyStyle: {
        padding: "0 8px 8px",
        width: "800px",
        height: "70vh",
        overflowY: "scroll",
        overflowX: "hidden",
      },
      activeKey,
      orderCustomerStatus:constant.orderCustomerStatus
    };
  },
  props: {
    routeLink: {
      type: String,
      default: "",
    },
  },
  watch: {
    routeLink: function (val) {
      this.changeTabNoEmit(Number(val || -1));
    },
  },
  computed: {
  },

  methods: {
    hideModal() {
      this.isShow = false;
    },
    emitRecord($event) {
      message.error($event.action);
    },
    openRecord(response) {
      this.detail = response.data.data;
      this.isShow = true;
      this.disabled = false;
    },
    handleDate($event) {
      let rangeDate = $event;
      if (Object.keys(rangeDate).length === 0) {
        rangeDate = {
          fromDate: "",
          toDate: "",
        };
      }
      let startDate = moment(
        rangeDate.fromDate == ""
          ? moment().startOf("month")
          : rangeDate.fromDate,
        "DD/MM/YYYY"
      ).format("YYYY/MM/DD");
      let endDate = moment(
        rangeDate.toDate == "" ? moment().endOf("month") : rangeDate.toDate,
        "DD/MM/YYYY"
      ).format("YYYY/MM/DD");
      let data = {
        fromDate: startDate,
        toDate: endDate,
      };
      this.eventBus.emit("changeRangeDate", data);
    },
    changeTab({ key, isEmit }) {
      if (key != null) {
        this.activeKey = key;
      } else {
        key = this.activeKey;
      }
      let filter = null;
      if (key !== -1) {
        filter = {
          field: "status",
          operator: "like",
          value: key,
        };
      } else {
        filter = {
          field: "status",
          operator: "like",
          value: null,
        };
      }
      this.$refs.list.reload(filter);
      if (isEmit) {
        this.$emit("changeTab", key);
      }
    },
    changeTabWithEmit(key) {
      this.changeTab({ key, isEmit: true });
    },
    changeTabNoEmit(key) {
      this.changeTab({ key, isEmit: false });
    },
  },
  mounted() {
    this.changeTabWithEmit();
  },
};
</script>


<style lang="scss">
.ant-row.ant-form-item {
  margin-bottom: 0px;
}
.card-box {
  padding: 10px;
  border: 1px solid rgba(54, 64, 74, 0.08);
  border-radius: 5px;
  background-clip: padding-box;
  margin-bottom: 12px;
  background: #fff;
}
</style>
